export const userName = "Ahmet Aslancan";
const phoneNumber = "+90 541 381 39 31";
const skypeId = "https://teams.live.com/l/invite/FEAhFuK4hUc018eVAE?v=g1";
const email = "elsanto710326@gmail.com";
const address = "NECMETTİN ERBAKAN MAH. YATALAKOĞLU 1. SK. ORGEÇ APT NO: 14 İÇ KAPI NO: 13 MERKEZ";
const birthday = "02 Nov 1990";
const age = new Date().getFullYear() - 1990;
const workingYear = new Date().getFullYear() - 2014;
export const contactInfo = {
    title: "Contact Me",
    info: [
        {
            title: "Phone",
            description: phoneNumber,
            icon: "fa fa-phone",
        },
        {
            title: "Address",
            description: address,
            icon: "fa fa-address-book",
        },
        {
            title: "Email",
            description: email,
            icon: "fa fa-envelope",
        },
        {
            title: "Skype",
            description: skypeId,
            icon: "fa fa-skype",
        },
    ]

}

export const portfolioInfo = {
    title: "Portfolio",
    info: [
        {
            label: "HlxLO",
            link: "http://5.253.43.204:5173",
            imgUrl: "assets/images/portfolio/hlxlo.png",
            category: "Game Development",
            description: "HIxLO is a simple crypto-based P2P Trading Game where players predict BTC price movements in real-time to earn money. ",
            skills: ["React", "Hook", "Node", "WebSocket", "Web3", "BlockChain", "MongoDB"],
        },
        {
            label: "Killer GF",
            link: "https://KillerGF.com",
            imgUrl: "assets/images/portfolio/022.png",
            category: "Web Development",
            description: "Killer GF is a 7,777 generative portrait art collection by a former Riot Games Artist, Zeronis, with over 240 meticulously designed features that contrasts cute and aesthetically appealing girlfriends that also happen to be dangerous assassins.",
            skills: ["React", "React-Redux", "Hook", "Web3", "BlockChain"],
        },
        {
            label: "Killer GF Cyber Run",
            link: "https://KillerGF.com",
            imgUrl: "assets/images/portfolio/006.png",
            category: "Game Development",
            description: "Killer GF is a 7,777 generative portrait art collection by a former Riot Games Artist, Zeronis, with over 240 meticulously designed features that contrasts cute and aesthetically appealing girlfriends that also happen to be dangerous assassins.",
            skills: ["Websocket", "React", "Unity", "WebGL", "NodeJS", "Web3", "BlockChain"],
        },
        {
            label: "Super Mario Run",
            link: "https://play.google.com/store/apps/details?id=com.nintendo.zara&pcampaignid=web_share",
            imgUrl: "assets/images/portfolio/021.png",
            category: "Game Development",
            description: "A new kind of Mario game that you can play with one hand. You control Mario by tapping as he constantly runs forward. You time your taps to pull off stylish jumps, midair spins, and wall jumps to gather coins and reach the goal! Super Mario Run can be downloaded for free and after you purchase the game, you will be able to play all the modes with no additional payment required. You can try out all four modes before purchase: World Tour, Toad Rally, Remix 10, and Kingdom Builder.",
            skills: ["Android", "IOS", "C#", "Unity"],
        },
        {
            label: "Dragalia Lost™",
            link: "https://dragalialost.com/en/",
            imgUrl: "assets/images/portfolio/020.png",
            category: "Game Development",
            description: "Dragalia Lost is a swipe-controlled action RPG about the bonds shared between humans and dragons. Conquer your enemies using an array of powerful attacks and special skills and even by transforming into a dragon yourself!",
            skills: ["Android", "IOS", "C#", "Unity"],
        },
        {
            label: "Mario Kart Tour",
            link: "https://play.google.com/store/apps/details?id=com.nintendo.zaka&pcampaignid=web_share",
            imgUrl: "assets/images/portfolio/019.png",
            category: "Game Development",
            description: "Challenge players worldwide in multiplayer! You can race against up to seven other players, whether they're registered as in-game friends, nearby, or scattered around the world. Multiplayer races can be customized with a variety of rules, such as individual or team races, kart speed, and number of item slots. You can play however you want!",
            skills: ["Android", "IOS", "C#", "Unity", "PUN", "Websocket", "Firebase"],
        },
        {
            label: "Beat Dancing",
            link: "https://play.google.com/store/apps/details?id=com.xgame.sonicdancer&pcampaignid=web_share",
            imgUrl: "assets/images/portfolio/018.png",
            category: "Game Development",
            description: "Let's enjoy the hot music and cool special effect! With the EDM music beat dancing out your life! Beat Dancing EDM:music game is an easy play game with one click simple operation, you just need to follow the rhythm, slide left or right and avoid all obstacles on the road. Tons of music library and varitries of music styles for your best experience! EDM Music+Beat Dancing+magic tiles=music game",
            skills: ["Unity", "C#", "Android Studio", "Java", "SDK", "URP"],
        },
        {
            label: "Carnage Crew",
            link: "https://carnage-crew.com/",
            imgUrl: "assets/images/portfolio/013.png",
            category: "Game Development",
            description: "This is the Carnage Crew website. It's shown Carnage Crew infomation and Unity WebGL Game.",
            skills: ["C#", "Unity", "Vue", "Smart Contract", "Web3"],
        },
        {
            label: "Poker Pretty Girls Battle: Fantasy World Edition",
            link: "https://www.mobygames.com/game/poker-pretty-girls-battle-fantasy-world-edition",
            imgUrl: "assets/images/portfolio/015.png",
            category: "Game Development",
            description: "Come play some hot rounds of poker at the Fantasy World casino! Try your luck against a total of 16 Pretty Girls including elves, magical girls, female swordsmen, and demons who are awaiting your arrival!",
            skills: ["Unity"],
        },
        {
            label: "Xedics & Sedica",
            link: "",
            imgUrl: "assets/images/portfolio/011.png",
            category: "App Development",
            description: "This project is to develop the world vessel management system. It's built with C#, DevExpress. This used api of https://www.marinetraffic.com",
            skills: ["C#", "WinForm", "DevExpress", "MySQL"],
        },
        {
            label: "NFT 3D Gallery",
            link: "",
            imgUrl: "assets/images/portfolio/003.png",
            category: "Game Development",
            description: "This project is to show and buy the art NFT.",
            skills: ["Unity", "NodeJS", "Express", "MySQL"],
        },
        {
            label: "Shibaverse",
            link: "https://shibaverse.io/",
            imgUrl: "assets/images/portfolio/014.png",
            category: "Game Development",
            description: "VERSE token is the native utility ERC-20 token for Shibaverse. Now I'm developing unity webgl game for this NFT",
            skills: ["Unity", "WordPress", "C#", "Node.js", "MySQL", "Websocket", "WebGL"],
        },
        {
            label: "Virtual Airport",
            link: "",
            imgUrl: "assets/images/portfolio/010.png",
            category: "Game Development",
            description: "This game is to manage the airport",
            skills: ["Unity", "NodeJS", "FireBase", "Figma", "Android"],
        },

        {
            label: "Pretty Girls Breakout!",
            link: "https://www.mobygames.com/game/pretty-girls-breakout",
            imgUrl: "assets/images/portfolio/016.png",
            category: "Game Development",
            description: "Classic brick-breaking action gets a cute and cuddly twist in Pretty Girls Breakers! In this classic arcade-style action puzzler, take the role of a twin-tailed fighter wielding a beam saber. You’ll have to strike incoming balls with precision to destroy block patterns above you, all while avoiding enemy attacks and collecting power-ups to gain the upper hand!Across more than 20 challenging stages, you’ll need to adapt to new blocks and enemy types, strategizing to clear them from the field without losing all of your hearts or running out of time! As stages are cleared, your female companions’ outfits will gradually change. If you succeed in battle, new outfits will be revealed and unlocked for viewing anytime in the alluring Dressing Room mode.",
            skills: ["Unity"],
        },
        {
            label: "Color 3D Ball",
            link: "https://play.google.com/store/apps/details?id=com.color.bump.balls.touch.marble.jump",
            imgUrl: "assets/images/portfolio/001.png",
            category: "Game Development",
            description: "In the game Avoid the different color types of obstacles to win. Protect the ball with your finger while it’s moving forward. This color 3D ball game is free and easy to play and highly addictive game. The color 3D is a perfect casual arcade game for all ages. Very easy to play, too hard to master. The game is one of the best bump games and it’s the most insane free game of 2019. This game is filled with colorful roads, color blocks, and realistic physics.",
            skills: ["Unity", "Android"],
        },
        {
            label: "Lotus Cars",
            link: "https://www.lotuscars.com",
            imgUrl: "assets/images/portfolio/002.png",
            category: "Web Development",
            description: "Lotus Cars Limited is a British automotive company headquartered in Norfolk, England. It manufactures sports cars and racing cars noted for their light weight and fine handling characteristics. Lotus was previously involved in Formula One racing, via Team Lotus, winning the Formula One World Championship seven times.",
            skills: ["React"],
        },
        {
            label: "Hotel WebSite",
            link: "https://static.imoveisroberta.com.br/index.php",
            imgUrl: "assets/images/portfolio/023.png",
            category: "Web Development",
            description: "Hotel Advertisement Site is a user-friendly site that allows customers to easily view information about the hotel they want and make reservations at any moment.",
            skills: ["PHP", "BootStrap", "JavaScript", "Axios", "MySQL"],
        },
        {
            label: "EverMerge: Merge 3 Puzzle",
            link: "https://play.google.com/store/apps/details?id=com.bigfishgames.mergetalesgoog",
            imgUrl: "assets/images/portfolio/004.png",
            category: "Game Development",
            description: "EverMerge is a magical world that gets bigger and better with each discovery. Come play this part merge, part world-building puzzle game. <br>EverMerge’s sandbox-style play offers endless possibilities and combinations! Find new mergeable items - and meet classic characters and creatures - as you complete puzzle quests and reveal new lands.",
            skills: ["Unity", "Firebase", "Android", "IOS"],
        },
        {
            label: "Music Racing",
            link: "https://play.google.com/store/apps/details?id=beatmaker.edm.musicgames.racinggame&pcampaignid=web_share",
            imgUrl: "assets/images/portfolio/017.png",
            category: "Game Development",
            description: "Drive in the music world, enjoy EDM music while racing! Tired of traditional music games? Music Racing GT will give you a totally different experience! Challenge yourself here, become a professional music racing driver! Feel the excitement of driving, beat the hit music and keep racing!",
            skills: ["Unity", "C#", "Android Studio", "Java", "SDK", "URP"],
        },
        {
            label: "14islands",
            link: "https://14islands.com/",
            imgUrl: "assets/images/portfolio/008.png",
            category: "Web Development",
            description: "We write code. Html, JavaScript, CSS, React… the whole package. We have a lot of experience doing it and, most importantly, build things the right way. We make sure to create scalable solutions that are fast and maintainable by your team in the future.",
            skills: ["React", "Three.js", "Redux", "Styled Component"],
        },
        {
            label: "Zombie Shooter",
            link: "https://play.google.com/store/apps/details?id=com.zombie.shooter.survives.killing.hunter.dead",
            imgUrl: "assets/images/portfolio/005.png",
            category: "Game Development",
            description: "The app moto is to Survive in a post-apocalypse wasteland killing zombies and stopping the dead rising on the last day of the world. The game gives functions like Take your sniper/rifle and fire weapons, aim to every walking dead and kill zombies as a lone survivor to prevent the end of the world.",
            skills: ["Unity"],
        },
        {
            label: "Tileset Game",
            link: "",
            imgUrl: "assets/images/portfolio/012.png",
            category: "Game Development",
            description: "This project is to match image. It's made by Unity",
            skills: ["Unity", "Android", "IOS"],
        },
        {
            label: "Vipealo",
            link: "https://www.vipealo.com/",
            imgUrl: "assets/images/portfolio/007.png",
            category: "Web Development",
            description: "travel destination reservation site",
            skills: ["React", "MySQL", "Payment Integration"],
        },
        {
            label: "Pure Flour From Europe",
            link: "https://pureflourfromeurope.com/play-with-us/",
            imgUrl: "assets/images/portfolio/009.png",
            category: "Web Development",
            description: "Pure Flour from Europe is a marketing and promotion programme launched in India under the charge of ITALMOPA, the Italian Milling Industry Association and co-sponsored by European Union.",
            skills: ["React", "WebGL", "Unity"],
        },
    ]

}

export const serviceInfo = {
    title: "Service",
    info: [
        {
            label: "Unity Game",
            content: "I have "  +9+  "+ years experiences to develop the unity game. I enjoy to play the game and also develop the it. I focused on to develop light and funny game. So i have the good result and experience.",
            icon: "fa fa-gamepad"
        },
        {
            label: "BlockChain",
            content: " Build, test and deploy custom smart contracts for your needs in Ethereum, Polygon, Avalanche, Polkadot, Solana and Cosmos blockchains.",
            icon: "fa fa-chain"
        },
        {
            label: "Web Frontend Development",
            content: "I'm Senior Frontend developer. So I will create responsible and flexible website. I always think how can i make best website when i develop.",
            icon: "fa fa-tv"
        },
        {
            label: "Web Backend Development",
            content: "Backend must be fast and sensible to request of client. So I always try to optimize the database and think about research the suitable algorithm.",
            icon: "fa fa-database"
        },
        {
            label: "App",
            content: "I have experiences to develop the android and iphone apps. mainly i developed medical care system and get some achievement. Also I integrate the SDK with Unity Games.",
            icon: "fa fa-mobile"
        },
        {
            label: "Analyze Database",
            content: "I think it is important to analyze the database before develop the program and built the own company. Database must be consersly and clarify.",
            icon: "fa fa-search"
        }
    ]

}

export const aboutInfo = {
    title: "About Me",
    subTitle: "<span>Crypto Trading, Betting Strategy Engineer & Full Stack Engineer</span>",
    description: "Hi! My name is <b>" + userName + "</b> from Turkey!</br>" +
        "</br>" +
        "I specialize in building crypto betting and blockchain-based gambling platforms and automation bots that are secure, scalable, and ready for real-world use.</br>" +
       "</br>" + " My experience comes from working on live betting systems, not proof-of-concepts, where accuracy, security, and uptime directly impact revenue and user trust.</br>" +
        "</br>" +
        "I’ve developed end-to-end crypto betting platforms, including sportsbook-style betting, casino-style games, and provably fair systems.</br>" +
        "</br>" + "Thanks.</br>",
        userInfo:  [
        {
            label: "Birthday",
            content: birthday
        },
        {
            label: "Age",
            content: age
        },
        // {
        //     label: "Website",
        //     content: personalSite
        // },
        {
            label: "Email",
            content: email
        },
        {
            label: "Degree",
            content: "Bachelor of Computer Science"
        },
        {
            label: "Phone",
            content: phoneNumber
        },
        {
            label: "Address",
            content: address
        },
        {
            label: "Freelance",
            content: "Available"
        }
    ],
    skillInfo: [
        {
            title: "Blockchain",
            progress: 99
        },
        {
            title: "Python",
            progress: 99
        },
        {
            title: "React",
            progress: 99
        },
       
        {
            title: "Node",
            progress: 99
        },
        {
            title: "Laravel",
            progress: 99
        },
        {
            title: "C#",
            progress: 99
        },
        {
            title: "ASP.NET MVC",
            progress: 99
        },
        {
            title: "Unity",
            progress: 99
        },
        {
            title: "MySQL",
            progress: 99
        },
    ],
    skills: [
        "Crypto Wallet Development",
        "Blochchain Architecture",
        "Smart Contract Development",
        "Game Mechanics",
        "Security Management",
        "Database Development",
        "Real Time Operating System",
        "API Development",
        "Front-End Development",
        "Back-End Development",
        "Algorithm Development",
        "Bot Development",
        "AI Chatbot",
    ],
    educationInfo: {
        title: "education",
        info: [
            {
                date: "2013 - 2017",
                title: "National Technical University of Ukraine ' Igor Sikorsky Kyiv Polytechnic Institute '",
                text: "Studied core computer science disciplines including algorithms, data structures, database systems, software engineering, and distributed systems. Completed academic projects focused on backend development, performance optimization, and system design. </br>" 
                        +"  Built a strong foundation in analytical thinking, problem solving, and writing efficient, maintainable code for complex systems.</b>."
            },
        ]
    },
    experienceInfo: {
        title: "experience",
        info: [
            {
                date: "June 2021 — November 2023",
                title: "Senior Blockchain & Betting Platfrom Developer",
                text: "<b>-</b> Integrated backend and blockchain for a crypto-based betting platform with sportsbook-style wagering and provably fair gaming. </br>" +
                      "<b>-</b>	Designed and implemented wallet systems for crypto deposits and withdrawals with transaction monitoring and confirmation across EVM-compatible networks. </br>" +
                      "<b>-</b> Developed core betting logic including odds processing, bet placement, settlement, and balance reconciliation. Focused on accuracy and financial integrity, Built REST APIs and real-time services for live betting, user account management, and transaction history.</br>" +
                      "<b>-</b> Implemented platform security features including role-based access control, rate limiting, audit logging, and anti-abuse protections. </br>" +
                      "<b>-</b> Optimized backend processes for high user concurrency and peak betting activities on betting.travelled. Coordinated with frontend developers on real-time odds and user transaction history updates.</br>" 
                    },
            {
                date: "Jan 2019 - June 2021",
                title: " Blockchain & Crypto Application Developer",
                text: "<b>-</b>Created web applications and backend services that incorporate blockchain technology for crypto services, including wallet systems, payment systems, and tools for tracking transactions.</br>"+ 
                    "<b>-</b>  I handled on-chain transactions and confirmations, and security integrations with Bitcoin and EVM-compatible blockchains. </br>"+ 
                    "<b>-</b>  Created secure APIS for crypto deposit, withdrawal, and internal balance management services. I concentrated on fund safety through adequate validation, logging, and transaction verification. I collaborated with KYC service integrations, payment processing, and blockchain analytics.</br>" +
                    "<b>-</b>  Designed systems with high reliability for accuracy and security that also gave me a financial edge.</br>" 
            },

             {
                date: "Jan 2019 - June 2025 ",
                title: " Casino trading, betting platform and automation bot development",
                text: "<b>-</b> https://bitstake.io/    </br>"+ 
                  "<b>-</b> https://tamisabet300.com/ </br>"+ 
                  "<b>-</b> https://docs.google.com/document/d/1ZmDM8wyJprFaqsFknNgUycW6tpNkfgJ0LESy9fJprnc/edit?tab=t.0#heading=h.xr1uctwau2qt</br>" +
                  "<b>-</b> https://www.veed.io/view/b7515c99-0b21-474c-ad49-5bfa1cc23cba?panel=share</br>" +
                  "<b></b></br>" +
                    "<b>-</b> I developed these two casino websites and hold full authority over the websites and admin pages</br>"+ 
                    "<b>-</b> I integrated the Blue Ocean and Timeless Casino APIs and developed bonus systems,cryptocurrency/bank account-based deposit and withdrawal systems, VIP/referral systems,and more.</br>" +
                    "<b>-</b> I have built a Polymarket bot applying the DCA Gabagul strategy.</br>" +
                    "<b>-</b> A human would never be able to make these calculations in real time, but the bot does it </br>" 
            },
        ]
    }
}

export const homeInfo = {
    title: "I enjoy to chat on Skype with you!!!",
    photoUrl: "assets/images/about.png",
    userName: userName,
    linkBtn: [
        {
            icon: "fa fa-skype",
            href: "https://join.skype.com/invite/DXREhASvd9UF"
        },
        // {
        //     icon: "fa fa-slack",
        //     href: ""
        //     //   href: "https://join.slack.com/t/minami-akira/shared_invite/zt-2kqny32c6-YhFS_4HnmHdUiE0pqVmL2w"
        // },
        {
            icon: "fa fa-telegram",
            href: "https://t.me/robert_7106"
        },
        {
            icon: "fa fa-calendar",
            href: "https://calendly.com/d/cqmn-zjg-fire9zv/30-minute-meeting"
        },
        {
            icon: "fa fa-linkedin",
            href: " https://www.linkedin.com/in/ahmet-%C3%A7elikaslan-4889962b3/"
        },
        // {
        //     icon: "fab fa-discord",
        //     href: ""
        //     //  href: "https://discord.com/users/1017964676719587388"
        // },
        {
            icon: "fa fa-github",
            href: ""
            // href: "https://github.com/Teymur-Babayev"
        },
        {
            icon: "fa fa-twitter",
            href: ""
            //  href: "https://twitter.com/toppawgameing"
        },
       
        {
            icon: "fa fa-steam",
            href: ""
            // href: "https://s.team/p/jmcd-jhpg/VPRKHDQJ"
        },

        {
            icon: "fa fa-facebook",
            href: ""
            // href: "https://www.facebook.com"
        },
        {
            icon: "fa fa-instagram",
            href: ""
            //   href: "https://www.instagram.com"
        },
    ]

}